import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactToPrint, useReactToPrint } from "react-to-print";
import NumberFormat from "react-number-format";

import { mdiPrinterSettings, mdiMicrosoftExcel } from "@mdi/js";
import Icon from "@mdi/react";
import moment from "moment";
import { Cookies } from "react-cookie";
import { Index_getConfigByKey } from "actions/DanhMuc";
import configs from "constants/configs";
import { getBranch } from "utils/utils";
import { convertDate } from "utils/currencyFormat";
import { getUserLogin } from "utils/utils";
import DatHangApi from "../../../../service/DatHang/DatHangApi";
import InDS from "Resources/ImagesNew/print-alt-5-white.png";
import LayoutNew from "common/LayoutNew";
import { Index_GetAllRoleInUser } from "actions/User";
import { formatNumber } from "utils/currencyFormat";

var numeral = require("numeral");

class ComponentToPrint extends React.Component {
    render() {
        return (
            <div
                style={{
                    padding: "10px",
                    margin: "5px",
                    backgroundColor: "#ffffff",
                    fontSize: "14px",
                    fontFamily: "tahoma",
                    marginBottom: "50px",
                    height: "fit-content", //fix lỗi giãn dòng khi in
                }}
                id="htmlPrint"
            >
                <div
                    dangerouslySetInnerHTML={{ __html: this.props.DataSend }}
                />
            </div>
        );
    }
}

export const PrintDonGuiDatHang = (props) => {
    const [dataDatHang, setDataDatHang] = useState('');
    const [isStartProcess, setIsStartProcess] = useState(false);
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let Code = params.get("Code");

    useEffect(() => {
        setIsStartProcess(true);
        DatHangApi.PrintChiTietDonHangGuiNCC(Code).then(
            (response) => {
                if (response.data) {
                    setDataDatHang(response.data)
                }
                setIsStartProcess(false);
            }
        );
    }, []);

    const componentRef = useRef();
    const danhmuc = useSelector((state) => state.danhmuc);
    const XuatExcel = () => {
        var uri =
            "data:application/vnd.ms-excel," +
            encodeURIComponent(document.getElementById("htmlPrint").outerHTML);
        var downloadLink = document.createElement("a");
        downloadLink.href = uri;
        downloadLink.download =
            "DonDatHangDaiLy" + moment().format("YYYYMMDDHHmm") + ".xls";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    return (
        <LayoutNew isPrint={true} isProgress={isStartProcess}>
            <ComponentToPrint
                ref={componentRef}
                DataSend={dataDatHang}
            />

            <div
                class="fixed"
                style={{ width: "100%", left: "0px", paddingRight: "30px" }}
            >
                <div style={{ width: "100%", clear: "both" }}>
                    <div style={{ marginTop: "25px", float: "right", display: "flex" }}>
                        {/* {roleInXuatExcel && ( */}
                        <>
                            <a
                                class="button-Add-NoIcon bg-blue-main"
                                href=""
                                onClick={XuatExcel}
                            >
                                <Icon
                                    path={mdiMicrosoftExcel}
                                    title="In"
                                    size={1.4}
                                    color="white"
                                />
                                &nbsp;Xuất excel
                            </a>{" "}
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <button
                                class="button-Icon-text bg-blue-main"
                                onClick={handlePrint}
                            >
                                <img src={InDS} title="In" alt="" /> &nbsp;In danh sách
                            </button>
                        </>
                        {/* )} */}
                    </div>
                </div>
            </div>
        </LayoutNew>
    );
};
